import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-loader',
  templateUrl: './loader.component.html',
  styles: [
    `
      .loader {
        width: 48px;
        height: 48px;
        border:10px solid #FFF;
        border-radius: 50%;
        position: relative;
        transform:rotate(45deg);
        box-sizing: border-box;
      }
      
      .loader::before {
        content: "";
        position: absolute;
        box-sizing: border-box;
        inset:-10px;
        border-radius: 50%;
        border:10px solid #FF3D00;
        animation: prixClipFix 2s infinite linear;
      }

      @keyframes prixClipFix {
          0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
          25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
          50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
          75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
          100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
      }
    `,
  ],
})
export class LoaderComponent {

  @Input('message')
  public message: string = '';
  
  @Input('is-loading')
  public isLoading: boolean = false;
  
  @Input('isClosing')
  public isClosing: boolean = false;

  @Input('zIndex')
  public zIndex: '' | 'z-0' | 'z-10' | 'z-20' | 'z-30' | 'z-40' | 'z-50' = '';

  public get classZIndex(): string {
    return `${this.zIndex} `;
  }

  public get classIsClosing(): string {
    return !this.isClosing ? 'animate__fadeIn ' : 'animate__fadeOut ';
  }
}